var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function mapKeysToChildren(children) {
  return _react.default.Children.map(children, function (child, index) {
    return _react.default.cloneElement(child, {
      key: index
    });
  });
}

var _default = mapKeysToChildren;
exports.default = _default;